/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "daddeef6b3359250892816b16a6873291255c781";
